import { useNavigate } from "react-router-dom";
import { BoxFiltros, ItensContainer } from "./style";
import Table from "./Table";
import Itens from "../../assets/item-serviço.svg";
import { useState } from "react";
import { ReactSVG } from "react-svg";

const Marcas = () => {
  const navigate = useNavigate();
  const [perfilSelecionado, setPerfilSelecionado] = useState("");
  const [textoPesquisa, setTextoPesquisa] = useState("");

  function NovaMarca() {
    navigate("/marca/nova");
  }

  return (
    <ItensContainer>
      <div className="box">
        <div className="flex">
          <ReactSVG src={Itens} />
          <h1>Marcas</h1>
        </div>
        <BoxFiltros>
          <div className="filtro">
            <input
              placeholder="Pesquisar por ID ou nome do item"
              value={textoPesquisa}
              onChange={(e) => setTextoPesquisa(e.target.value)}
            />
            <div>
              <p>Filtrar por status</p>
              <select
                value={perfilSelecionado}
                onChange={(e) => setPerfilSelecionado(e.target.value)}
              >
                <option value="">Ver todos</option>
                <option value={1}>ativo</option>
                <option value={0}>inativo</option>
              </select>
            </div>
          </div>
          <button onClick={NovaMarca}>Nova Marca</button>
        </BoxFiltros>
        <Table
          perfilSelecionado={perfilSelecionado}
          textoPesquisa={textoPesquisa}
        />
      </div>
    </ItensContainer>
  );
};

export default Marcas;
